export const WORK = "/";
export const ABOUT = "/about";
export const CONTACT = "/contact";
export const CASE_2 = "/cJungle-app";
export const CASE_3 = "/real estate dashboard&crm";
export const CASE_7 = "/real estate sales-tool";
export const CASE_6 = "/driving-app";
export const CASE_8 = "/flynas-design-impact";
